import CustomTooltip from '@components/tooltip/Tooltip';
import useIsTruncated from '@hooks/useIsTruncated';

interface TruncateCellProps {
  id: string;
  value: string;
}

const TruncateCell = ({ id, value }: TruncateCellProps) => {
  const { ref, isTruncated } = useIsTruncated<HTMLSpanElement>(value);

  return (
    <>
      <span
        ref={ref}
        className="block truncate"
        data-tooltip-id={`truncate-${id}`}
      >
        {value}
      </span>
      {isTruncated && (
        <CustomTooltip
          id={`truncate-${id}`}
          type="text"
          tooltipText={value}
          place="top"
        />
      )}
    </>
  );
};

export default TruncateCell;
